var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEuroMiddle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M9.35,26.3a16,16,0,1,0,16-16,16,16,0,0,0-16,16",
    transform: "translate(-9.35 -10.305)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(-9.35 -10.305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4312",
    "data-name": "Group 4312",
    transform: "translate(9.35 10.305)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2035",
    "data-name": "Rectangle 2035",
    width: 38.085,
    height: 38.364,
    transform: "translate(-2.97 -3.274)",
    fill: "#00237c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M55.44,15.753l.491,1.51h1.588l-1.284.933.49,1.51-1.284-.933-1.284.933.491-1.51-1.284-.933H54.95Z",
    transform: "translate(-39.379 -14.022)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M55.44,92.557l.491,1.51h1.588L56.234,95l.49,1.51-1.284-.933-1.284.933L54.646,95l-1.284-.933H54.95Z",
    transform: "translate(-39.379 -66.426)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M93.912,54.283l.491,1.51H95.99l-1.284.933.491,1.51L93.912,57.3l-1.284.933.491-1.51-1.284-.933h1.588Z",
    transform: "translate(-65.629 -40.311)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M17.038,54.154l.491,1.51h1.588l-1.284.933.491,1.51-1.284-.934-1.284.934.491-1.51-1.285-.933h1.588Z",
    transform: "translate(-13.178 -40.223)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M22.158,34.7l.491,1.51h1.588l-1.285.933.491,1.51-1.285-.933-1.284.933.491-1.51-1.284-.933h1.588Z",
    transform: "translate(-16.671 -26.948)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M35.855,20.617l.491,1.51h1.588l-1.285.933.491,1.51-1.284-.933-1.285.933.491-1.51-1.285-.933h1.588Z",
    transform: "translate(-26.016 -17.341)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M88.082,34.7l.491,1.51h1.588l-1.284.933.49,1.51-1.284-.933-1.284.933.491-1.51L86,36.207h1.588Z",
    transform: "translate(-61.651 -26.948)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M74.257,20.617l.491,1.51h1.588l-1.285.933.491,1.51-1.284-.933-1.285.933.491-1.51-1.285-.933h1.588Z",
    transform: "translate(-52.218 -17.341)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M22.158,73.1l.491,1.51h1.588l-1.285.933.491,1.51-1.285-.933-1.284.933.491-1.51L20.08,74.61h1.588Z",
    transform: "translate(-16.671 -53.15)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M35.855,86.8l.491,1.51h1.588l-1.285.933.491,1.51-1.284-.933-1.285.933.491-1.51-1.285-.933h1.588Z",
    transform: "translate(-26.016 -62.495)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M88.082,73.1l.491,1.51h1.588l-1.284.933.49,1.51-1.284-.933-1.284.933.491-1.51L86,74.61h1.588Z",
    transform: "translate(-61.651 -53.15)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M74.257,86.8l.491,1.51h1.588l-1.285.933.491,1.51-1.284-.933-1.285.933.491-1.51-1.285-.933h1.588Z",
    transform: "translate(-52.218 -62.495)",
    fill: "#fc0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEuroMiddle);
export default __webpack_public_path__ + "static/media/icon_euro_middle.def3de9ca96e7058415ac33a7770a59c.svg";
export { ForwardRef as ReactComponent };